/* Tatagaltier storefront reviews — build-spec §5 #9 / §7.
   Talks to the reviews app via the Shopify app proxy (/apps/reviews/*):
   - GET  list  → renders rating distribution + review cards (paginated)
   - POST submit → write-a-review form (Turnstile lazy-loaded, honeypot, verified badge)
   Fails quietly (keeps the server-side summary) if the proxy is unavailable. */
(function () {
  const root = document.querySelector("[data-tata-reviews-root]");
  if (!root) return;

  const productId = root.dataset.productId;
  const listUrl = root.dataset.listUrl;
  const submitUrl = root.dataset.submitUrl;
  const turnstileKey = root.dataset.turnstileKey || "";

  const distEl = root.querySelector("[data-reviews-dist]");
  const listEl = root.querySelector("[data-reviews-list]");
  const emptyEl = root.querySelector("[data-reviews-empty]");
  const moreBtn = root.querySelector("[data-reviews-more]");
  const openBtn = root.querySelector("[data-reviews-open]");
  const formWrap = root.querySelector("[data-reviews-form-wrap]");
  const form = root.querySelector("[data-reviews-form]");
  const msgEl = root.querySelector("[data-reviews-msg]");

  let page = 1;
  let sort = "newest";

  const esc = (s) =>
    String(s == null ? "" : s).replace(/[&<>"']/g, (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c],
    );
  const stars = (n) =>
    '<span class="tata-review-card__stars" aria-hidden="true">' +
    "★".repeat(n) +
    '<span class="tata-review-card__stars-empty">' + "★".repeat(5 - n) + "</span></span>";

  function renderDistribution(dist, total) {
    if (!distEl || !total) return;
    let html = "";
    for (let r = 5; r >= 1; r--) {
      const c = dist[r] || 0;
      const pct = total ? Math.round((c / total) * 100) : 0;
      html +=
        `<div class="tata-reviews__dist-row"><span class="tata-reviews__dist-label">${r}★</span>` +
        `<span class="tata-reviews__dist-track"><span class="tata-reviews__dist-fill" style="width:${pct}%"></span></span>` +
        `<span class="tata-reviews__dist-count">${c}</span></div>`;
    }
    distEl.innerHTML = html;
    distEl.hidden = false;
  }

  function reviewCard(r) {
    return (
      `<li class="tata-review-card">` +
      `<div class="tata-review-card__head">${stars(r.rating)}</div>` +
      (r.title ? `<p class="tata-review-card__title">${esc(r.title)}</p>` : "") +
      `<p class="tata-review-card__body">${esc(r.body)}</p>` +
      `<div class="tata-review-card__meta">` +
      `<span class="tata-review-card__author">— ${esc(r.author)}</span>` +
      (r.verified ? `<span class="tata-review-card__verified">Verified Buyer</span>` : "") +
      `</div>` +
      `</li>`
    );
  }

  async function loadList(reset) {
    if (!listUrl) return;
    try {
      const res = await fetch(
        `${listUrl}?product_id=${encodeURIComponent(productId)}&page=${page}&sort=${sort}`,
        { headers: { Accept: "application/json" } },
      );
      if (!res.ok) throw new Error("proxy " + res.status);
      const data = await res.json();

      if (reset) listEl.innerHTML = "";
      if (page === 1) renderDistribution(data.distribution || {}, data.total || 0);

      if (!data.total) {
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;

      // listEl is the <ul> itself — append <li> cards directly (horizontal carousel)
      (data.reviews || []).forEach((r) => listEl.insertAdjacentHTML("beforeend", reviewCard(r)));

      if (moreBtn) moreBtn.hidden = !data.has_more;
    } catch (e) {
      // Proxy unavailable (e.g. app not installed on this store) — keep the static summary.
      console.warn("reviews list unavailable", e);
      if (moreBtn) moreBtn.hidden = true;
    }
  }

  /* ---------- write a review ---------- */
  let turnstileLoaded = false;
  function loadTurnstile() {
    if (!turnstileKey || turnstileLoaded) return;
    turnstileLoaded = true;
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  }

  if (openBtn && formWrap) {
    openBtn.addEventListener("click", () => {
      const show = formWrap.hidden;
      formWrap.hidden = !show;
      openBtn.setAttribute("aria-expanded", String(show));
      if (show) {
        loadTurnstile();
        formWrap.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    });
  }

  if (form) {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      if (msgEl) { msgEl.textContent = ""; msgEl.className = "tata-reviews__msg"; }
      const btn = form.querySelector("[type=submit]");
      if (btn) btn.disabled = true;
      try {
        const res = await fetch(submitUrl, { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } });
        const data = await res.json().catch(() => ({}));
        if (res.ok && data.ok) {
          form.reset();
          if (msgEl) { msgEl.textContent = data.message || "Thank you! Your review is pending approval."; msgEl.className = "tata-reviews__msg tata-reviews__msg--ok"; }
          if (typeof window.turnstile !== "undefined") try { window.turnstile.reset(); } catch (_) {}
        } else {
          if (msgEl) { msgEl.textContent = data.error || "Something went wrong. Please try again."; msgEl.className = "tata-reviews__msg tata-reviews__msg--error"; }
        }
      } catch (err) {
        if (msgEl) { msgEl.textContent = "Could not submit right now. Please try again later."; msgEl.className = "tata-reviews__msg tata-reviews__msg--error"; }
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  }

  if (moreBtn) moreBtn.addEventListener("click", () => { page += 1; loadList(false); });

  loadList(true);
})();
